import { FronteggAppOptions } from "@frontegg/types";

const fronteggOptions: FronteggAppOptions =
  // @ts-expect-error -- CYPRESS_CONFIG is injected at runtime and not typed
  window.CYPRESS_CONFIG ||
  ({
    contextOptions: {
      baseUrl: import.meta.env.VITE_FRONTEGG_BASEURL,
      clientId: import.meta.env.VITE_FRONTEGG_CLIENT_ID,
    },
    entitlementsOptions: {
      enabled: true,
    },
    customLoader: true,
  } as FronteggAppOptions);

export default fronteggOptions;
